import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom"; // Use useNavigate to handle redirects
import {
  getAdminProfile,
  getAdmins,
  getStudentApplication,
  getStudentDetails,
  retrieveStudentDetails,
} from "../../services/admin.services";
import { useDispatch, useSelector } from "react-redux";
import { setAdmins } from "../../state/reducers/adminSlice";
import { setCustomers } from "../../state/reducers/customerSlice";
import { getCustomers } from "../../services/customer.services";
import { setLeads } from "../../state/reducers/leadSlice";
import axios from "axios";
import { getLeads } from "../../services/lead.services";
import { setInvoices } from "../../state/reducers/invoiceSlice";
import { getInvoices } from "../../services/invoice.services";
import { setDirectories } from "../../state/reducers/resourcesSlice";
import { setUser, setUserDetails } from "../../state/reducers/userSlice";

// Function to check if token is expired
const isTokenExpired = () => {
  const expirationTime = localStorage.getItem("expires");
  if (!expirationTime) return true; // No expiration time set, treat as expired
  const currentTime = new Date().getTime();
  return currentTime > expirationTime;
};

const StudentMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Use navigate for redirecting
  const user_id = useSelector((state) => state.user.user_id);
  const role = useSelector((state) => state.user.role);

  const getStudentProfile = async (user_id) => {
    try {
      const res = await getStudentDetails(user_id);
      dispatch(setUserDetails(res.data));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    // Check if token is expired
    if (isTokenExpired()) {
      localStorage.removeItem("token");
      navigate("/login"); // Redirect to login page if token is expired
    } else {
      getStudentProfile(user_id);
    }
  }, [dispatch, navigate, user_id]);

  return (
    <div className="bg-[#BCDFFF]">
      <Outlet />
    </div>
  );
};

export default StudentMain;
